// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4i-6";
export var headerCell = "_4i-2";
export var rowWrapper = "_4i-4";
export var stickyAggregationCell = "_4i-a";
export var stickyAggregationRow = "_4i-7";
export var stickyColumnCell = "_4i-9";
export var stickyColumnHeaderCell = "_4i-8";
export var table = "_4i-1";
export var virtualRowWrapper = "_4i-5";
export var virtualTableContainer = "_4i-0";
export var white = "_4i-3";